import {
  useRestaurantLocationsQuery,
  Restaurant,
  GeneralError
} from 'src/apollo/onlineOrdering'

import { useOOClient } from 'shared/components/common/oo_client_provider/OOClientProvider'
import { useRestaurant } from 'shared/components/common/restaurant_context/RestaurantContext'
import { SiteRestaurantLocation } from 'shared/js/types'

type I18n = Restaurant['i18n']
type BookingConfig = Restaurant['bookingConfig']

export type OOLocation = SiteRestaurantLocation & {
  i18n?: I18n
  bookingConfig?: BookingConfig
}

export const useOOLocations = (): OOLocation[] | undefined => {
  const { locations } = useRestaurant()
  const client = useOOClient()
  const { data } = useRestaurantLocationsQuery({
    variables: {
      restaurantGuids: locations?.map((loc) => loc.externalId) ?? []
    },
    skip: !locations?.length,
    client
  })

  const locationsDataByGuid = data?.restaurants?.reduce(
    (acc: { [key: string]: Restaurant }, loc: Restaurant | GeneralError) => {
      if (loc.__typename === 'Restaurant') {
        acc[loc.guid] = loc
      }
      return acc
    },
    {}
  )

  return locations
    ?.filter(
      (loc) => locationsDataByGuid?.[loc.externalId]?.hasOnlineOrderingModule
    )
    .map((loc) => ({
      ...loc,
      i18n: locationsDataByGuid?.[loc.externalId]?.i18n,
      bookingConfig: locationsDataByGuid?.[loc.externalId]?.bookingConfig
    }))
}

export default useOOLocations
